module.exports = __webpack_public_path__ + "static/media/our-map.d78a849e.webp";